import { Navigate } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";
import { pageRoute } from "../utils/common";

const PrivateRoute = ({ children }) => {
  const { isAuthenticated } = useAuth();
  return isAuthenticated ? children : <Navigate to={pageRoute.login} replace />;
};

export default PrivateRoute;
